// introRows — rows a page puts in its helper's pane without a chat turn (the
// Tables helper's opening summary), merged into the chat's own messages by
// time. Equal times keep their order, chat messages first.

import type { AgentMessage } from '../types.js'

export function mergeIntroRows(messages: AgentMessage[], intro: AgentMessage[] | undefined): AgentMessage[] {
  if (!intro || intro.length === 0) return messages
  const at = (m: AgentMessage) => {
    const t = Date.parse(m.timestamp)
    return Number.isNaN(t) ? 0 : t
  }
  // Array.prototype.sort is stable, so equal times keep this order.
  return [...messages, ...intro].sort((a, b) => at(a) - at(b))
}
